import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import AboutIntroSection from "../components/AboutUs/AboutIntroSection";
import MissionVisionSection from "../components/AboutUs/MissionVisionSection";
import ContactMotivationBanner from "../components/AboutUs/AboutMotivationBanner";
import ValuesSection from "../components/AboutUs/ValuesSection";
import BlackDividerBottom from "../components/SectionDivider/BlackDividerBottom";
import BlackDividerTop from "../components/SectionDivider/BlackDividerTop";
import CoachesSection from "../components/AboutUs/CoachesSection";

function AboutUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Acerca de NovaXFit | Gimnasio en La Libertad</title>
        <meta
          name="description"
          content="Conoce NovaXFit, gimnasio en La Libertad, provincia de Santa Elena. Nuestra misión, visión, valores y equipo de entrenadores."
        />
        <link rel="canonical" href="https://novaxfit.com/acerca-de-nosotros" />
      </Helmet>

      <div>
        <AboutIntroSection />
        <MissionVisionSection />
        <ContactMotivationBanner />
        <CoachesSection />
        <BlackDividerBottom />
        <ValuesSection />
        <BlackDividerTop />
      </div>
    </>
  );
}

export default AboutUs;